export default class Formularios {
    constructor() {
    
        this.forms = document.querySelectorAll('.wpforms-form')
        
        this.ready();
    }
    
    ready() {

        // this.forms.forEach(form => {
        //     const formID = +form.dataset.formid
        //     if(formID === 642) {
        //         form.setAttribute('name', 'Site Simples'); 
        //     } else if(formID === 647) {
        //         form.setAttribute('name', 'site-podcast');
        //     } else if(formID === 645) {
        //         form.setAttribute('name', 'site-radio-indoor');
        //     } else if(formID === 649) {
        //         form.setAttribute('name', 'site-radio-web');
        //     } else if(formID === 651) {
        //         form.setAttribute('name', 'site-scent');
        //     } else if(formID === 653) {
        //         form.setAttribute('name', 'site-tv-indoor');
        //     }
        // })



    }

}